import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import {
  SkillsClientContext,
  SKILLS_CLIENT_STATES,
} from 'components/shared/Skills/SkillsClientProvider';

export function useGetSkillTemplatesForLessonlyContent({
  lessonlyContentId,
  lessonlyContentType,
}) {
  const { client, status } = useContext(SkillsClientContext);

  return useQuery(
    [
      'get-skill-templates-for-lessonly-content',
      lessonlyContentId,
      lessonlyContentType,
    ],
    async () => {
      const variables = {
        lessonlyContentId,
        lessonlyContentType,
      };
      return client.request(
        gql`
          query GetSkillTemplatesForLessonlyContent(
            $lessonlyContentId: Int!
            $lessonlyContentType: String
          ) {
            skillTemplatesForLessonlyContent(
              lessonlyContentId: $lessonlyContentId
              lessonlyContentType: $lessonlyContentType
            ) {
              skillTemplates {
                id
                name
                description
              }
            }
          }
        `,
        variables,
      );
    },
    {
      enabled:
        !!lessonlyContentId &&
        !!lessonlyContentType &&
        status === SKILLS_CLIENT_STATES.SUCCESS,
    },
  );
}
